import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css';
import './print.css';
import App from './components/App';
import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducer from './reducers'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { detect } from 'detect-browser'
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig";


export const msalInstance = new PublicClientApplication(msalConfig);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const logger = store => next => action => {
    let result = next(action)
    if (window.location.hostname.indexOf('localhost') === -1) {
        return result
    }
    console.group("[DEBUG]", action.type);
    console.log("dispatching", action);

    //console.log("store after");
    //console.log(store.getState())
    console.groupEnd("[DEBUG]", action.type);
    return result
}

const store = createStore(
    reducer,
    composeEnhancers(
        applyMiddleware(logger, thunk)
    )
)

msalInstance.initialize().then(() => {
    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Optional - This will update account state if a user signs in from another tab or window
    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    const container = document.getElementById("root");
    const root = ReactDOM.createRoot(container);

    root.render(
        <Router>
            <Provider store={store}>
                <App pca={msalInstance} />
            </Provider>
        </Router>
    );
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

setTimeout(function () {
    if (window.screen && window.screen.logicalXDPI && window.screen.deviceXDPI) {
        document.body.style.zoom = window.screen.logicalXDPI / window.screen.deviceXDPI;
    }
}, 5000);

//browser support, only exclude IE
const browser_s = detect();
const sb = ['ie'];
if (browser_s && sb.indexOf(browser_s.name) > -1) {
    window.location.href = "ie.html";
}